module.exports = __webpack_public_path__ + "static/media/Aviso_organizadores.9a582cab.pdf";